import { render, staticRenderFns } from "./AddPickupTable.vue?vue&type=template&id=777ce485&"
import script from "./AddPickupTable.vue?vue&type=script&lang=js&"
export * from "./AddPickupTable.vue?vue&type=script&lang=js&"
import style0 from "./AddPickupTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports